import React, { useEffect ,useState} from "react";
import CopyableListInput from "../cartAddress/CustomInputAndTitle";
import CustomCardCount from "./customCardCount";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import LoadingSpinner from "../animation/LoadingSpinner";
import { getAnalyticsData } from "../../redux/reducer/analyticsDataReducer";

const BoxSection = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { data, loading, error } = useSelector((state) => state.analytics);

  useEffect(() => {
      dispatch(getAnalyticsData());
    }, [dispatch]);
    if(loading) {
      return <LoadingSpinner />  
    }
  return (
    <div className="w-full">
      {/* Box Number Section */}
      <div className="items-center justify-between gap-4 mb-6 md:flex">
        <h3 className="text-xl text-black">{t("BoxNumber")}</h3>
        <CopyableListInput title={data?.boxNumber} />
      </div>

      {/* Card Counts Section */}
      <div className="flex items-center justify-center w-full">
        <div className="w-2/3">
          <CustomCardCount
            title={t("MyBox")}
            count={data?.products}
            subTitle={t("Piece")}
            className="flex-1"
          />
        </div>
        <div className="w-2/3">
          <CustomCardCount
            title={t("Shipments")}
            count={data?.carts}
            subTitle={t("Shipment")}
            className="flex-1"
          />
        </div>
        <div className="w-2/3">
          <CustomCardCount
            title={t("Notifications")}
            count={data?.notifications}
            subTitle={t("NewNotification")}
            className="flex-1"
          />
        </div>
      </div>
    </div>
  );
};

export default BoxSection;
